import './css/style.css';
import { ErrorBoundary } from 'react-error-boundary';
import { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Checkout from './pages/Checkout/Checkout';
import Products from './pages/Products/Products';
import ProductDetails from './pages/ProductDetails/ProductDetails';
import PageNotFound from './pages/404/PageNotFound';
import Confirmation from './pages/Confirmation/Confirmation';
import ShopLayout from './components/hoc/ShopLayout';
import Error from './pages/Error/Error';
import PaymentCallback, { LegacyPaymentCallback } from './components/PaymentCallback';
import { Loader } from './components/ui/loader';

const App = () => {
  const location = useLocation();

  useEffect(() => {
    document.querySelector('html')!.style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html')!.style.scrollBehavior = '';
  }, [location.pathname]); // triggered on route change

  return (
    <>
      <ErrorBoundary onError={() => {}} onReset={() => {}} FallbackComponent={Error}>
        <Routes>
          <Route
            path="/:code"
            element={
              <Suspense fallback={<Loader />}>
                <ShopLayout />
              </Suspense>
            }
          >
            <Route index element={<Navigate to="products" />} />
            <Route path="products" element={<Products />} />
            <Route path="products/:id" element={<ProductDetails />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="confirmation/:orderId" element={<Confirmation />} />
            <Route path="callback" element={<PaymentCallback />} />
          </Route>

          {/* Swish payments started before the callback moved under /:code still return here */}
          <Route path="/callback" element={<LegacyPaymentCallback />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </ErrorBoundary>
    </>
  );
};

export default App;
